import { jsx as _jsx } from "react/jsx-runtime";
import { Flex, freddyTheme, Typography } from '@coolblue-development/freddy';
export const CategoryNavigationBarGroup = ({ onMouseOver, onKeydown, isActive, group, }) => (_jsx(Flex, { tabIndex: 0, onMouseOver: onMouseOver, onKeyDown: onKeydown, alignItems: "center", component: "li", sx: {
        position: 'relative',
        listStyleType: 'none',
        borderBottom: `${freddyTheme.borderWidth[75]} solid ${isActive ? freddyTheme.color.border.secondary : 'transparent'}`,
        transition: 'border-bottom 150ms ease-in-out',
        padding: `${freddyTheme.spacing[400]} ${freddyTheme.spacing[100]} 1.3rem`,
    }, children: _jsx(Typography, { color: "interactiveBase", fontWeight: 600, textAlign: "center", children: group.title }) }));
//# sourceMappingURL=CategoryNavigationBarGroup.js.map